export default {

 // Assets
  assets: {
    options: (brandId, fieldName) => `search/options/${brandId}/${fieldName}`,
    updateTopics: id => `/assets/${id}/update_topics`,
    updateKeywords: id => `/assets/${id}/update_keywords`,
    updatePropertyValues: id => `/assets/${id}/update_property_values`,
    viewAndScrollStats: id => `/assets/${id}/view_and_scroll_stats`,
    socialStats: id => `social-stats/${id}`,
    consumptionStats: id => `completion-stats/${id}`,
    conversionStats: id => `conversion-stats/${id}`,
    listTopics: () => `v2/assets/topics/`
  },

  // NebulaSearch
  search: {
    search: () => '/search',
    export: () => '/search/export'
  },

  quickInsights: {
    list: () => '/quick-insights',
    detail: pk => `/quick-insights/${pk}`
  },

  // These endpoints will be replaced when we refactor the saved search
  // feature.
  savedSearch: {
    list: () => `/saved-searches`,
    detail: searchId => `/saved-searches/${searchId}`
  },

  // Collections
  collections: {
    list: () => `v2/assets/collections`,
    detail: pk => `v2/assets/collections/${pk}`
  },
  brands: {
    languages: brandId => `/brands/${brandId}/languages`,
    hostNames: brandId => `/brands/${brandId}/host-names`
  },

  metrics: {
    create: () => '/metrics'
  },

  // Categories
  categories: {
    list: () => '/categories/'
  },

  keywords: {
    list: () => '/keywords'
  },

  articles: {
    updateCustomTags: id => `/articles/${id}/update-custom-tags`
  },
  videos: {
    updateCustomTags: id => `/videos/${id}/update-custom-tags`
  },
  images: {
    updateCustomTags: id => `/images/${id}/update-custom-tags`
  },

  // These are duplicates until the old keys are deleted after we have fully
  // migrated to the new search backend.
  'ContentType.ARTICLE': {
    updateCustomTags: id => `/articles/${id}/update-custom-tags`
  },
  'ContentType.VIDEO': {
    updateCustomTags: id => `/videos/${id}/update-custom-tags`
  },
  'ContentType.IMAGE': {
    updateCustomTags: id => `/images/${id}/update-custom-tags`
  },

  customProperties: {
    list: () => `/custom-properties`,
    detail: pk => `/custom-properties/${encodeURIComponent(pk)}`
  },

  properties: {
    list: () => '/properties',
    detail: pk => `/properties/${pk}`
  },

  assetProperties: {
    list: () => '/assetproperties',
    detail: pk => `/assetproperties/${pk}`
  }
}
